export const SKILLS = ['attack', 'serve', 'block', 'reception', 'dig', 'set'];

export const QUALITY_SYMBOLS = ['#', '+', '!', '-', '/', '='];

export const SKILL_LABELS = {
    attack: 'Атака',
    serve: 'Подача',
    block: 'Блок',
    reception: 'Приём',
    dig: 'Защита',
    set: 'Передача',
};

export const QUALITY_TITLES = {
    attack: {
        '#': 'Очко',
        '+': 'Усложнено',
        '!': 'Не забито',
        '-': 'Плохо',
        '/': 'Блок',
        '=': 'Ошибка',
    },
    serve: {
        '#': 'Эйс',
        '+': 'Позитивная',
        '!': 'Недостаточная',
        '-': 'Плохая',
        '/': 'Очень позитивная',
        '=': 'Ошибка',
    },
    block: {
        '#': 'Очко',
        '+': 'Позитивный',
        '!': 'Недостаточный',
        '-': 'Плохой',
        '/': 'Второй темп',
        '=': 'Ошибка',
    },
    reception: {
        '#': 'Идеальный',
        '+': 'Позитивный',
        '!': 'Недостаточный',
        '-': 'Негативный',
        '/': 'Очень плохой',
        '=': 'Ошибка',
    },
    dig: {
        '#': 'Идеальная',
        '+': 'Позитивная',
        '!': 'Недостаточная',
        '-': 'Негативная',
        '/': 'Очень позитивная',
        '=': 'Ошибка',
    },
    set: {
        '#': 'Идеальная',
        '+': 'Позитивная',
        '!': 'Недостаточная',
        '-': 'Негативная',
        '/': 'Второй темп',
        '=': 'Ошибка',
    },
};

export const COMPETITION_TYPES = [
    { value: 'championship', label: 'Чемпионат' },
    { value: 'cup', label: 'Кубок' },
    { value: 'supercup', label: 'Суперкубок' },
];

export const COMPETITION_ICONS = {
    championship: '/images/championship.png',
    cup: '/images/cup.png',
    supercup: '/images/supercup.png',
};

export const STAGE_OPTIONS = {
    championship: [
        { value: 'championship:regular-1', label: 'Предварительный (1-й круг)' },
        { value: 'championship:regular-2', label: 'Предварительный (2-й круг)' },
        { value: 'championship:quarterfinal', label: 'Четвертьфинальный' },
        { value: 'championship:semifinal', label: 'Полуфинальный' },
        { value: 'championship:5-places-1', label: 'Финальный за 5-9 места (1-й круг)' },
        { value: 'championship:5-places-2', label: 'Финальный за 5-9 места (2-й круг)' },
        { value: 'championship:third_place', label: 'Матчи за 3 место', medal: 'bronze' },
        { value: 'championship:final_1_4', label: 'Финальный за 1-4 места', medal: 'gold' },
    ],
    cup: [
        { value: 'cup:group_stage', label: 'Групповой (3 группы по 3 команды, 2 круга)' },
        { value: 'cup:cup_additional', label: 'Дополнительный (3 игры)' },
        { value: 'cup:semifinal', label: 'Полуфиналы' },
        { value: 'cup:third_place', label: 'Матч за 3 место', medal: 'bronze' },
        { value: 'cup:final', label: 'Финальный', medal: 'gold' },
    ],
    supercup: [],
};

const LEGACY_STAGE_KEY_MAP = {
    championship_preliminary: ['championship:regular-1', 'championship:regular-2'],
    quarterfinal: ['championship:quarterfinal'],
    semifinal: ['championship:semifinal', 'cup:semifinal'],
    third_place: ['championship:third_place', 'cup:third_place'],
    final_1_4: ['championship:final_1_4'],
    final_5_9: ['championship:5-places-1', 'championship:5-places-2'],
    group_stage: ['cup:group_stage'],
    cup_additional: ['cup:cup_additional'],
    final: ['cup:final'],
};

export function getStagesForCompetitionTypes(competitionTypes) {
    const stages = [];

    (competitionTypes || []).forEach((compType) => {
        if (STAGE_OPTIONS[compType]) {
            stages.push(...STAGE_OPTIONS[compType]);
        }
    });

    return stages;
}

export function getCompetitionStageGroups() {
    return COMPETITION_TYPES.map((competition) => ({
        value: competition.value,
        label: competition.label,
        stages: STAGE_OPTIONS[competition.value] || [],
    }));
}

export function parseStageFilterKey(filterKey) {
    if (filterKey.includes(':')) {
        const [competitionType, stageKey] = filterKey.split(':', 2);

        return { competitionType, stageKey };
    }

    return { competitionType: null, stageKey: filterKey };
}

export function normalizeStageKeys(stages, competitionTypes) {
    if (!stages?.length) {
        return [];
    }

    const available = getStagesForCompetitionTypes(competitionTypes);
    const availableValues = new Set(available.map((stage) => stage.value));
    const normalized = [];

    stages.forEach((stage) => {
        if (availableValues.has(stage)) {
            normalized.push(stage);
            return;
        }

        const { stageKey } = parseStageFilterKey(stage);
        const legacyKeys = LEGACY_STAGE_KEY_MAP[stageKey] || LEGACY_STAGE_KEY_MAP[stage] || [];

        legacyKeys.forEach((key) => {
            if (availableValues.has(key)) {
                normalized.push(key);
            }
        });
    });

    return [...new Set(normalized)];
}

export function isFullStageSelection(stages, competitionTypes) {
    const available = getStagesForCompetitionTypes(competitionTypes).map((stage) => stage.value);

    if (!available.length) {
        return true;
    }

    if (!stages?.length) {
        return true;
    }

    return available.every((value) => stages.includes(value));
}

export function getDefaultDraftFilters(seasons) {
    const currentSeason = seasons.find((s) => s.is_active) || seasons[0];

    return {
        season_ids: currentSeason ? [currentSeason.id] : [],
        team_ids: [],
        position_slugs: [],
        competition_types: ['championship', 'cup', 'supercup'],
        stages: [],
        match_ids: [],
    };
}

export function filterMatchesByDraft(matches, appliedFilters, draftFilters) {
    let result = matches;

    if (appliedFilters.season_ids?.length) {
        result = result.filter((match) => appliedFilters.season_ids.includes(match.season_id));
    }

    if (draftFilters.competition_types.length) {
        result = result.filter(
            (match) => match.competition_type && draftFilters.competition_types.includes(match.competition_type)
        );
    }

    if (shouldApplyStageFilter(draftFilters.stages, draftFilters.competition_types)) {
        const fivePlacesRoundIndex = buildFivePlacesRoundIndex(result);

        result = result.filter((match) =>
            matchPassesStageFilter(
                match,
                draftFilters.stages,
                draftFilters.competition_types,
                fivePlacesRoundIndex
            )
        );
    }

    return result;
}

export function buildFivePlacesRoundIndex(matches) {
    const toursBySeason = {};

    matches.forEach((match) => {
        if (match.stage !== '5-places' || match.tour_number == null) {
            return;
        }

        const seasonId = match.season_id;
        (toursBySeason[seasonId] ||= new Set()).add(match.tour_number);
    });

    const index = {};

    Object.entries(toursBySeason).forEach(([seasonId, tourSet]) => {
        const tours = [...tourSet].sort((a, b) => a - b);
        const mid = Math.ceil(tours.length / 2);

        tours.slice(0, mid).forEach((tour) => {
            index[`${seasonId}:${tour}`] = 1;
        });
        tours.slice(mid).forEach((tour) => {
            index[`${seasonId}:${tour}`] = 2;
        });
    });

    return index;
}

export function matchFivePlacesRound(match, round, roundIndex) {
    if (match.stage !== '5-places' || match.tour_number == null) {
        return false;
    }

    return roundIndex[`${match.season_id}:${match.tour_number}`] === round;
}

export function matchMatchesStage(matchStage, stageKey) {
    if (stageKey === 'championship_preliminary') {
        return matchStage === 'regular-1' || matchStage === 'regular-2';
    }
    if (stageKey === 'final_1_4') {
        return matchStage === 'final';
    }
    if (stageKey === 'final_5_9') {
        return matchStage === '5-places';
    }
    if (stageKey === 'cup_additional') {
        return matchStage === 'dop';
    }
    return matchStage === stageKey;
}

export function matchMatchesStageFilter(match, filterKey, roundIndex = null) {
    const { competitionType, stageKey } = parseStageFilterKey(filterKey);

    if (competitionType && match.competition_type !== competitionType) {
        return false;
    }

    if (stageKey === '5-places-1' || stageKey === '5-places-2') {
        const round = stageKey === '5-places-1' ? 1 : 2;
        return matchFivePlacesRound(match, round, roundIndex ?? {});
    }

    return matchMatchesStage(match.stage, stageKey);
}

function shouldApplyStageFilter(stages, competitionTypes) {
    return stages?.length > 0 && !isFullStageSelection(stages, competitionTypes);
}

function matchPassesStageFilter(match, selectedStages, competitionTypes, roundIndex = null) {
    const competitionType = match.competition_type;
    const stageOptions = STAGE_OPTIONS[competitionType] || [];

    if (!match.stage && stageOptions.length === 0) {
        return competitionTypes.includes(competitionType);
    }

    return selectedStages.some((stage) => matchMatchesStageFilter(match, stage, roundIndex));
}

export function expandFilterSelection(appliedFilters, { teams, positions, matches, appliedFilters: seasonContext }) {
    const competitionTypes = appliedFilters.competition_types?.length
        ? [...appliedFilters.competition_types]
        : ['championship', 'cup', 'supercup'];
    const stages = getStagesForCompetitionTypes(competitionTypes);
    const stageValues = stages.map((stage) => stage.value);
    const normalizedStages = appliedFilters.stages?.length
        ? normalizeStageKeys(appliedFilters.stages, competitionTypes)
        : stageValues;

    const draftForMatches = {
        competition_types: competitionTypes,
        stages: normalizedStages,
    };
    const filteredMatches = filterMatchesByDraft(matches, seasonContext || appliedFilters, draftForMatches);

    return {
        season_ids: [...(appliedFilters.season_ids || [])],
        team_ids: appliedFilters.team_ids?.length ? [...appliedFilters.team_ids] : teams.map((team) => team.id),
        position_slugs: appliedFilters.position_slugs?.length
            ? [...appliedFilters.position_slugs]
            : positions.map((position) => position.slug),
        competition_types: competitionTypes,
        stages: appliedFilters.stages?.length ? normalizedStages : stageValues,
        match_ids: appliedFilters.match_ids?.length
            ? [...appliedFilters.match_ids]
            : filteredMatches.map((match) => match.id),
    };
}

export function compactFilterSelection(draftFilters, { teams, positions, matches, appliedFilters }) {
    const filteredMatches = filterMatchesByDraft(matches, appliedFilters, draftFilters);

    return {
        season_ids: [...(draftFilters.season_ids || [])],
        team_ids:
            draftFilters.team_ids.length === teams.length && teams.length > 0
                ? []
                : [...draftFilters.team_ids],
        position_slugs:
            draftFilters.position_slugs.length === positions.length && positions.length > 0
                ? []
                : [...draftFilters.position_slugs],
        competition_types: [...(draftFilters.competition_types || [])],
        stages: isFullStageSelection(draftFilters.stages, draftFilters.competition_types)
            ? []
            : [...draftFilters.stages],
        match_ids:
            draftFilters.match_ids.length === filteredMatches.length && filteredMatches.length > 0
                ? []
                : [...draftFilters.match_ids],
    };
}

export function buildAppliedQueryParams(filters) {
    const params = {};

    if (filters.season_ids?.length) params.season_ids = filters.season_ids;
    if (filters.team_ids?.length) params.team_ids = filters.team_ids;
    if (filters.position_slugs?.length) params.position_slugs = filters.position_slugs;
    if (filters.competition_types?.length) params.competition_types = filters.competition_types;
    if (filters.stages?.length) params.stages = filters.stages;
    if (filters.match_ids?.length) params.match_ids = filters.match_ids;

    return params;
}
